// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IPublicV1ChatsBulkOperationsReadAllFromSectionDesktopRequestSchema {
  /** Секция, из которой нужно прочитать все чаты **/
  section: ESection;
}

export enum ESection {
  /** Раздел "Архив" **/
  'Archive' = 'archive',
  /** Раздел "Сообщения" **/
  'Main' = 'main',
  /** Раздел "Непрочитанные" **/
  'Unread' = 'unread',
}
